import PaymentPolicy from "../Components/Other/PaymentPolicy";

const Payment = () => {
  return <PaymentPolicy />;
};

export default Payment;
